<template>
  <el-container>
    <el-aside width="64px" class="left" style="height: calc(100vh);padding: 0px;">
      <el-row class="head-icon">
        <div>
          <img :src="apiUrl+'/file/getOneByByte?md5='+imageUrl" v-if="imageUrl!=null&&imageUrl!=''" style="border-radius: 50%;"/>
          <img src="../../assets/head-icon.png" v-if="imageUrl==null||imageUrl==''" style="border-radius: 50%;"/>
        </div>
      </el-row>
      <el-row v-for="(menu, index) in menus" :key="index">
        <div class="item-menu-cur" v-if="index==menuCurIndex" v-on:click="choseMenu(index, menu)">
          <i :class="menu.icon"></i>
          <div>{{menu.name}}</div>
        </div>
        <div class="item-menu" v-if="index!=menuCurIndex" v-on:click="choseMenu(index, menu)">
          <i :class="menu.icon"></i>
          <div>{{menu.name}}</div>
        </div>
        <el-row v-for="(cmenu, cindex) in menu.children" :key="cindex" v-if="menuCurIndex==index">
          <div class="item-menu-cur-c" v-if="cindex==cmenuCurIndex" v-on:click="choseCMenu(cindex, cmenu)">
            <div>{{cmenu.name}}</div>
          </div>
          <div class="item-menu-c menu" v-if="cindex!=cmenuCurIndex" v-on:click="choseCMenu(cindex, cmenu)">
            <div>{{cmenu.name}}</div>
          </div>
        </el-row>
      </el-row>
    </el-aside>
    <el-container>
      <el-header class="header" height="56px">
        <el-row>
          <div class="chose-menu">
            <i :class="menuCur.icon"></i>
            <div>{{menuCur.name}}</div>
          </div>
          <div class="users-menu">
            <div class="message" @click="dialogMessageVisible = true">
              <el-badge :value="notReadMsgNum" class="item"><i class="fa fa-envelope-o"></i></el-badge>
            </div>
            <el-dropdown>
              <span class="el-dropdown-link">
                {{ user.username }}<i class="el-icon-arrow-down el-icon--right"></i>
              </span>
              <el-dropdown-menu slot="dropdown">
                <el-dropdown-item><div @click="digEditPassword()">修改密码</div></el-dropdown-item>
                <el-dropdown-item><div @click="dialogUserInfoVisible=true" v-if="config.syncPersonEnabel===false">修改个人信息</div></el-dropdown-item>
                <el-dropdown-item divided><div v-on:click="loginOut">账号退出</div></el-dropdown-item>
              </el-dropdown-menu>
            </el-dropdown>
          </div>
        </el-row>
      </el-header>
      <el-main class="main" style="height: calc(100vh - 56px - 20px);padding-bottom: 0px;">
        <router-view></router-view>
      </el-main>
    </el-container>
    <el-dialog title="修改密码" :visible.sync="dialogFormVisible">
      <el-form :model="form">
        <el-form-item label="旧密码" :label-width="formLabelWidth">
          <el-input v-model="form.oldPassword" autocomplete="off"></el-input>
        </el-form-item>
        <el-form-item label="新密码" :label-width="formLabelWidth">
          <el-input v-model="form.newPassword" autocomplete="off"></el-input>
        </el-form-item>
        <el-form-item label="密码确认" :label-width="formLabelWidth">
          <el-input v-model="form.sureNewPassword" autocomplete="off"></el-input>
        </el-form-item>
      </el-form>

      <div slot="footer" class="dialog-footer">
        <el-button @click="dialogFormVisible = false">取 消</el-button>
        <el-button type="primary" @click="submitForm()" style="background-color: #209323;" >确 定</el-button>
      </div>
    </el-dialog>
    <el-dialog title="个人信息" :visible.sync="dialogUserInfoVisible">
      <el-form :model="formUserInfo">
        <el-form-item label="用户ID" :label-width="formLabelWidth">
          <el-input v-model="formUserInfo.userId" autocomplete="off" readonly disabled></el-input>
        </el-form-item>
        <el-form-item label="姓名" :label-width="formLabelWidth">
          <el-input v-model="formUserInfo.name" autocomplete="off"></el-input>
        </el-form-item>
        <el-form-item label="身份证" :label-width="formLabelWidth">
          <el-input v-model="formUserInfo.idcard" autocomplete="off"></el-input>
        </el-form-item>
        <el-form-item label="手机" :label-width="formLabelWidth">
          <el-input v-model="formUserInfo.phone" autocomplete="off"></el-input>
        </el-form-item>
        <el-form-item label="性别" :label-width="formLabelWidth">
          <el-radio-group v-model="formUserInfo.sex" size="medium">
            <el-radio-button label=1>男</el-radio-button>
            <el-radio-button label=2>女</el-radio-button>
            <el-radio-button label=0>未知</el-radio-button>
          </el-radio-group>
        </el-form-item>
        <el-form-item label="邮箱" :label-width="formLabelWidth">
          <el-input v-model="formUserInfo.email" autocomplete="off"></el-input>
        </el-form-item>
        <el-form-item label="标签" :label-width="formLabelWidth">
          <el-input v-model="formUserInfo.labels" autocomplete="off" placeholder="英文','逗号分隔" readonly disabled></el-input>
        </el-form-item>
      </el-form>

      <div slot="footer" class="dialog-footer">
        <el-button @click="dialogUserInfoVisible = false">取 消</el-button>
        <el-button type="primary" @click="submitForm()" style="background-color: #209323;" >确 定</el-button>
      </div>
    </el-dialog>
    <el-dialog title="消息列表" :visible.sync="dialogMessageVisible" width="90%" top="10px">
      <MessageComponent></MessageComponent>
    </el-dialog>
  </el-container>
</template>

<script>
import requestService from '../../util/request'
import MessageComponent from '../manage-components/message/Index.vue'
export default {
  components: {
    MessageComponent
  },
  data () {
    return {
      apiUrl: '',
      menus: [],
      menuCurIndex: 0,
      cmenuCurIndex: -1,
      formLabelWidth: '120px',
      menuCur: {},
      user: {},
      userInfo: {},
      dialogFormVisible: false,
      dialogUserInfoVisible: false,
      dialogMessageVisible: false,
      imageUrl: null,
      form: {
        oldPassword: '',
        newPassword: '',
        sureNewPassword: ''
      },
      formUserInfo: {
        id: null,
        addTime: null,
        upTime: null,
        userId: null,
        name: null,
        idcard: null,
        phone: null,
        sex: null,
        email: null,
        labels: null
      },
      notReadMsgNum: 0,
      config: {}
    }
  },
  created () {
    this.loadPermissiones()
    this.getUserDetail()
    this.seNotReadMesNum()
    this.seConfig()
    this.apiUrl = this.$global.apiUrl
  },
  methods: {
    loadPermissiones: function () {
      let that = this
      requestService.get('/permission/getPermissionListByUserId?dealTree=true', {
      }, {headers: {'Content-Type': 'application/x-www-form-urlencoded'}}).then((res) => {
        that.menus = res.data.body
        if (that.menus && that.menus.length > 0) {
          that.choseMenu(0, that.menus[0])
        }
      })
    },
    getUserDetail: function () {
      let that = this
      localStorage.removeItem('user')
      localStorage.removeItem('userInfo')
      requestService.get('/user/getUserDetail', {
      }, {headers: {'Content-Type': 'application/x-www-form-urlencoded'}}).then((res) => {
        that.user = res.data.body
        that.imageUrl = that.user.imageUrl
        console.log(that.imageUrl)
        localStorage.setItem('user', JSON.stringify(that.user))
      })
      requestService.get('/userInfo/getUserInfoDetail', {
      }, {headers: {'Content-Type': 'application/x-www-form-urlencoded'}}).then((res) => {
        that.userInfo = res.data.body
        that.formUserInfo = {...res.data.body}
        localStorage.setItem('userInfo', JSON.stringify(that.userInfo))
      })
    },
    choseMenu: function (index, menu) {
      console.log(index)
      this.menuCurIndex = index
      this.menuCur = menu
      if (this.menuCur.url === '#') {

      } else {
        this.$router.push({path: this.menuCur.url})
      }
    },
    choseCMenu: function (index, cmenu) {
      console.log(index)
      this.cmenuCurIndex = index
      this.menuCur = cmenu
      this.$router.push({path: this.menuCur.url})
    },
    loginOut: function (e) {
      console.log(e)
      localStorage.removeItem('token')
      requestService.post('/loginOut', {
      }).then((res) => {
        this.$router.push({path: '/'})
      })
    },
    digEditPassword () {
      this.form = {}
      this.dialogFormVisible = true
    },
    submitForm () {
      let that = this
      that.dialogFormVisible = false
      requestService.post('/user/editPassword', that.form, {headers: {'Content-Type': 'application/json'}}).then((res) => {
      })
    },
    seNotReadMesNum () {
      let that = this
      requestService.get('/message/countNotRead', {}, {headers: {'Content-Type': 'application/json'}}).then((res) => {
        that.notReadMsgNum = res.data.count
      })
    },
    seConfig () {
      requestService.get('/common/config', {}, {headers: {'Content-Type': 'application/x-www-form-urlencoded'}}).then((res) => {
        this.config = res.data.body
        localStorage.setItem('appConfig', JSON.stringify(this.config))
      })
    }
  }
}
</script>

<style scoped>
@import '../../assets/manage-base.css';
@import '../../assets/manage-index.css';
</style>



// WEBPACK FOOTER //
// src/components/manage/Index.vue